export default __webpack_public_path__ + "static/media/6f4dc61ab94c8e7ca96781732233f847.svg";